// extracted by mini-css-extract-plugin
export default {"residentList":"resident_list_residentList__pni7e","Mui-focused":"resident_list_Mui-focused__zC9GA","label":"resident_list_label__vnW-+"};